
import React from 'react';
import SummaryCards from '@/components/telemetry/SummaryCards';
import DeviceStatusChart from '@/components/telemetry/DeviceStatusChart';
import PerformanceMetricsChart from '@/components/telemetry/PerformanceMetricsChart';
import { Device } from '@/components/device-health/gis-map/types';

interface TelemetryTabContentProps {
  chartData: any[];
  latestData: any;
  selectedSection: string | null;
  onCardClick: (section: string) => void;
  telemetryType: 'energy' | 'gas' | 'water';
  gatewayStatusRef: React.RefObject<HTMLDivElement>;
  performanceMetricsRef: React.RefObject<HTMLDivElement>;
  deviceId?: string;
  deviceData?: Device | null;
}

const TelemetryTabContent: React.FC<TelemetryTabContentProps> = ({
  chartData,
  latestData,
  selectedSection,
  onCardClick,
  telemetryType,
  gatewayStatusRef,
  performanceMetricsRef,
  deviceId,
  deviceData
}) => {
  // Filter or adapt data based on device ID if present
  const filteredChartData = deviceId 
    ? chartData.map(item => ({
        ...item,
        // Here we could filter or adjust the data for the specific device
        // This is a placeholder for when we have more granular data
      }))
    : chartData;

  return (
    <div className="space-y-6">
      {/* Summary Cards */}
      <SummaryCards 
        latestData={latestData} 
        selectedSection={selectedSection} 
        onCardClick={onCardClick} 
        deviceData={deviceData}
      />
      
      {/* Device Status Chart */}
      <div ref={gatewayStatusRef}>
        <DeviceStatusChart 
          chartData={filteredChartData} 
          selectedSection={selectedSection} 
          onCardClick={onCardClick} 
          sectionName="gatewayStatus" 
          deviceData={deviceData}
        />
      </div>
      
      {/* Performance Metrics */}
      <div ref={performanceMetricsRef}>
        <PerformanceMetricsChart 
          chartData={filteredChartData} 
          selectedSection={selectedSection} 
          onCardClick={onCardClick} 
          sectionName="performanceMetrics" 
          telemetryType={telemetryType} 
          deviceId={deviceId}
          deviceData={deviceData}
        />
      </div>
    </div>
  );
};

export default TelemetryTabContent;
